import { useState, useEffect } from 'react';
import WelcomeScreen from './components/WelcomeScreen';
import OrderForm from './components/OrderForm';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';

function App() {
  const [currentView, setCurrentView] = useState<'welcome' | 'order'>('welcome');
  const { trackPageView } = useGoogleAnalytics();

  const handleBackToHome = () => {
    setCurrentView('welcome');
  };

  // Track page views when the current view changes
  useEffect(() => {
    if (currentView === 'welcome') {
      trackPageView('/', 'Mimi Iams - Custom House Pillows');
    } else if (currentView === 'order') {
      trackPageView('/order', 'Commission Order Form - Mimi Iams');
    }
  }, [currentView, trackPageView]);

  // Track initial page load
  useEffect(() => {
    if (currentView === 'welcome') {
      trackPageView('/', 'Mimi Iams - Custom House Pillows');
    }
  }, [trackPageView]);

  return (
    <div className="min-h-screen">
      {currentView === 'welcome' && (
        <WelcomeScreen />
      )}
      {currentView === 'order' && (
        <OrderForm
          onBack={handleBackToHome}
        />
      )}
    </div>
  );
}

export default App;